/**
 * 高德地图常用变量
 */
export const amapSettings = {
  loadOptions: {
    // 申请好的Web端开发者Key，首次调用 load 时必填
    key: 'b92193e679565bd6246ce746a8d79c64',
    // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
    // version: '1.4.15',
    version: '2.0',
    // version: '2.1Beta',
  },
  mapStyle: 'amap://styles/c677b92336fcfd0bdb6bf3ba350dd0cf',
  icons: {
    success: require('../assets/images/amap/success.png'),
    warning: require('../assets/images/amap/warning.png'),
    error: require('../assets/images/amap/error.png'),
    cold: require('../assets/images/amap/cold.png'),
  }
}
export const secretKey = '326820fb70b26457fe44b07e8036cf7b'

/**
 * 生成setFitView所需的覆盖物
 * @param AMap
 * @param points
 */
export function createFitViewOverlays (AMap, points: { lnglat: [number, number] | { lng: number, lat: number } }[]) {
  const min = { lng: Infinity, lat: Infinity }
  const max = { lng: -Infinity, lat: -Infinity }
  let lngKey = 'lng', latKey = 'lat'
  if (Array.isArray(points[0].lnglat)) {
    lngKey = '0'; latKey = '1'
  }
  for (let i = 0, len = points.length; i < len; i++) {
    const { lnglat } = points[i]
    if (lnglat[lngKey] < min.lng) min.lng = lnglat[lngKey]
    if (lnglat[latKey] < min.lat) min.lat = lnglat[latKey]
    if (lnglat[lngKey] > max.lng) max.lng = lnglat[lngKey]
    if (lnglat[latKey] > max.lat) max.lat = lnglat[latKey]
  }
  return [
    new AMap.Marker({ position: [min.lng, min.lat] }),
    new AMap.Marker({ position: [max.lng, max.lat] }),
  ]
}
